import { Routes } from "@angular/router";

import { FullComponent } from "./layouts/full/full.component";
import { AppBlankComponent } from "./layouts/blank/blank.component";
import { AuthGuard } from "./authentication/guard/auth.guard";

export const AppRoutes: Routes = [
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "/project-setting/project-list",
        pathMatch: "full",
      },
      {
        path: "dashboards",
        loadChildren: () =>
          import("./dashboards/dashboards.module").then(
            (m) => m.DashboardsModule
          ),
      },
      {
        path: "discount",
        loadChildren: () =>
          import("./discount/discount.module").then((m) => m.DiscountModule),
      },
      {
        path: "developer-user",
        loadChildren: () =>
          import("./developer-user/developer-user.module").then(
            (m) => m.DeveloperUserModule
          ),
      },
      {
        path: "company-setting",
        loadChildren: () =>
          import("./company-setting/company-setting.module").then(
            (m) => m.CompanySettingModule
          ),
      },
      {
        path: "event",
        loadChildren: () =>
          import("./event/event.module").then((m) => m.EventModule),
      },
      {
        path: "payment",
        loadChildren: () =>
          import("./payment/payment.module").then((m) => m.PaymentModule),
      },
      {
        path: "general-setting",
        loadChildren: () =>
          import("./general-setting/general-setting.module").then(
            (m) => m.GeneralSettingModule
          ),
      },
      {
        path: "project-setting",
        loadChildren: () =>
          import("./project-setting/project-setting.module").then(
            (m) => m.ProjectSettingModule
          ),
      },
      {
        path: "purchaser-payment-plan",
        loadChildren: () =>
          import("./purchaser-payment-plan/purchaser-payment-plan.module").then(
            (m) => m.SalesPackageModule
          ),
      },
      {
        path: "others",
        loadChildren: () =>
          import("./others/others.module").then((m) => m.OthersModule),
      },
      {
        path: "team-setting",
        loadChildren: () =>
          import("./team-setting/team-setting.module").then(
            (m) => m.TeamSettingModule
          ),
      },
      {
        path: "banker-setting",
        loadChildren: () =>
          import("./banker-setting/banker-setting.module").then(
            (m) => m.BankerSettingModule
          ),
      },
      {
        path: "solicitor-setting",
        loadChildren: () =>
          import("./solicitor-setting/solicitor-setting.module").then(
            (m) => m.SolicitorSettingModule
          ),
      },
      {
        path: "news-announcements",
        loadChildren: () =>
          import("./news-announcements/news-announcements.module").then(
            (m)=> m.NewsAnnouncementsModule
          ),
      },
      {
        path: "setting",
        loadChildren: () =>
          import("./setting/setting.module").then((m) => m.SettingModule),
      },
      {
        path: "purchaser-app-setting",
        loadChildren: () => import("./purchaser-app-setting/purchaser-app-setting.module").then((m) => m.PurchaserAppSettingModule)
      }
    ],
  },
  {
    path: "authentication",
    component: AppBlankComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./authentication/authentication.module").then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "authentication/404",
  },
];
